import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import { Box, Typography } from "@mui/material";
import React from "react";
import { dashboardCardBgColor, grayFontColor } from "../cssUtils/constants";
import typography from "../cssUtils/typography";

const DashboardBadge = ({ title, value, label, Icon, textColor, sx = {}, }) => {
  return (
    <Box
      sx={{
        paddingX: 1,
        paddingY: 3,
        pl: 2,
        backgroundColor: dashboardCardBgColor,
        display: "flex",
        justifyContent: "space-between",
        flexDirection: "column",
        gap: "8px",
        alignItems: "start",
        textAlign: "start",
        // minWidth: "150px",
        width: "100%",
        borderRadius: "8px",
        ...sx,  
      }}
    >
      {title && (
        <Typography
          variant="body2"
          sx={{
            ...typography.h2,
            weight: "500",
          }}
        >
          {title}{" "}
        </Typography>
      )}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontWeight: "600",
            fontSize: "20px",
            color: textColor,
          }}
        >
          {value}{" "}
        </Typography>
        {Icon && (
          <Icon
            sx={{
              fontSize: "20px",
              color: textColor,
            }}
          />
        )}
      </Box>
      {label && (
        <Typography
          sx={{ color: "#807E7E", fontSize: "14px", fontWeight: "500" }}
          variant="body2"
        >
          {label}
        </Typography>
      )}
    </Box>
  );
};

export default DashboardBadge;
